import { ServiceFieldValueMessage } from "./ServiceFieldValueMessage"

export class CreateOrderServiceMessage {
  customerVisible: boolean
  note: string
  serviceFieldValues: ServiceFieldValueMessage[]
  serviceId: number

  constructor(customerVisible: boolean, note: string, serviceFieldValues: ServiceFieldValueMessage[], serviceId: number) {
    this.customerVisible = customerVisible
    this.note = note
    this.serviceFieldValues = serviceFieldValues
    this.serviceId = serviceId
  }
}
